// extracted by mini-css-extract-plugin
export var clauseRow = "_g2-6";
export var emptyState = "_g2-d";
export var filterContent = "_g2-a";
export var filterGroup = "_g2-1";
export var filterGroupContainer = "_g2-0";
export var nestedGroup = "_g2-2";
export var nestedGroupContent = "_g2-b";
export var nestedGroupDepth1 = "_g2-3";
export var nestedGroupDepth2 = "_g2-4";
export var nestedGroupDepth3 = "_g2-5";
export var nestedGroupEmpty = "_g2-c";
export var operatorAnd = "_g2-8";
export var operatorOr = "_g2-9";
export var operatorToggle = "_g2-7";
export var removeGroupButton = "_g2-e";